import { z } from "zod";
/**
 * The runs list wire shape.
 *
 * Defined here, not in the API, because the browser has to validate what it
 * receives. Two hand-written copies of the same shape drift the first time
 * either is touched, and the drift shows up as a runtime error in a screen
 * rather than a type error in a build.
 */
export const runSummarySchema = z.object({
    id: z.string(),
    engine: z.string(),
    promptText: z.string(),
    /** null while the capture is queued or running. It has no outcome yet. */
    terminalState: z.string().nullable(),
    /** ISO date, no time. The capture day, not the moment it finished. */
    runDate: z.string(),
    attempt: z.number().int(),
    finishedAt: z.string().nullable(),
    /**
     * null means no answer was recorded. Distinct from 0, which would mean the
     * engine answered with an empty string — a different fact.
     */
    answerChars: z.number().int().nullable(),
    citationCount: z.number().int(),
    inlineCitationCount: z.number().int(),
    /** True once the evidence manifest hash is stored against the run. */
    sealed: z.boolean(),
});
export const runListSchema = z.object({ runs: z.array(runSummarySchema) });
//# sourceMappingURL=runs.js.map